/**
 *
 *
 * pc端 下拉题
 *
 * optionForm === 1
 *
 *   AQ类型
 * derection === 1
 *
 *
 */
import React, { useState } from "react";
import { Input, Table, Select } from "antd";
import { cloneDeep } from "lodash";
import ReactJson from "react-json-view";
import { InputWapper } from "@/utils/helper";
import { language } from "@/utils/language";
const descriptionRender = (text) => {
  let html = text
    .replace(/<p><\/p>/g, "<br />")
    .replace(/\n\n/g, "<br />")
    .replace(/\s{2}/g, "&nbsp;&nbsp;");

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
};

export default ({ info, answer, changeAnswer }) => {
  console.log(`src\\pages\\matrix\\MatrixSelect\\web\\AQ.jsx`);
  const { childs } = info;
  const [showInput, setShowInput] = useState({});

  const handleInputChange = (questionId, value) => {
    const answers = answer[info.id] || answer;
    const newAnswer = cloneDeep(answers);
    const obj = newAnswer[questionId];
    const [answerId] = Object.keys(obj);
    newAnswer[questionId][answerId] = value;
    changeAnswer(newAnswer);
  };

  const handleChange = (question, answerId) => {
    const { id: questionId } = question;
    const newAnswer = cloneDeep(answer);
    newAnswer[info.id] = newAnswer[info.id] || {};
    newAnswer[info.id][questionId] = { [answerId]: null };
    changeAnswer(newAnswer[info.id]);
    // 半开放框
    const option = question.options.find((o) => o.id === answerId);
    const { open } = option;
    setShowInput({ ...showInput, [questionId]: !!open });
  };

  const optionRender = (question) => (text, record, index) => {
    const answers = answer[info.id] || answer;
    const value = Object.keys(answers[question.id] || {})[0];
    const inputValue =
      answers?.[question.id]?.[value]?.text || answers?.[question.id]?.[value];
    const select = (
      <Select
        style={{ width: "100%", textAlign: "left" }}
        value={value}
        onChange={(value) => handleChange(question, value)}
      >
        {question.options
          .filter((o) => !o.hide && !o.moduleOption)
          .map((o) => (
            <Select.Option key={o.id}>
              {descriptionRender(o.description)}
            </Select.Option>
          ))}
      </Select>
    );
    const input = (
      <InputWapper unit={question.unit}>
        <Input
          placeholder={language().input_placeholder}
          defaultValue={inputValue}
          onChange={(e) => handleInputChange(question.id, e.target.value)}
        />
      </InputWapper>
    );

    return (
      <div style={{ margin: 4 }}>
        {select} {(showInput[question.id] || inputValue) && input}
      </div>
    );
  };

  const data = childs.filter((o) => !o.hide && !o.moduleOption);
  const columns = data.map((o) => ({
    title: descriptionRender(o.description),
    dataIndex: "description",
    width: `${data.length / 100}%`,
    align: "center",
    render: optionRender(o),
  }));

  return (
    <>
      {document.domain === "localhost" && (
        <ReactJson src={answer} collapsed={false} />
      )}
      <Table
        rowKey="id"
        bordered
        pagination={false}
        columns={columns}
        dataSource={[{}]}
      />
    </>
  );
};
